import {request} from '@/assets/js/request.js'
let fixUrl='app20/order-service/order20'
const getPayInfo = (data) => {//获取订单支付信息
    return request({
        method: 'post',
        url: `${fixUrl}/api/order/payment/applyOnlinePay`,
        data,
    })
}
const getPayInfoNew = (data) => {//获取订单支付信息
  return request({
      method: 'post',
      url: `${fixUrl}/api/order/payment/applyOnlinePayUnion`,
      data,
  })
}
const applyAlipay = (data) => {//支付宝支付
    return request({
        method: 'post',
        url: `${fixUrl}/api/order/payment/applyAlipay`,
        data,
    })
}
const applyAlipayNew = (data) => {//支付宝支付
    return request({
        method: 'post',
        url: `${fixUrl}/api/order/payment/applyAlipayUnion`,
        data,
    })
}
const applyWechatpay = (data) => {//wx支付
    return request({
        method: 'post',
        url: `${fixUrl}/api/order/payment/applyWechatpay`,
        data,
    })
}
const applyWechatpayNew = (data) => {//wx支付2
    return request({
        method: 'post',
        url: `${fixUrl}/api/order/payment/applyWechatpayUnion`,
        data,
    })
}

const getPayState = (data) => {//获取支付状态
    return request({
        method: 'post',
        url: `${fixUrl}/api/order/payment/onlinePaymentInfoByVersion`,
        data,
    })
}

const getPayWXInfo = (data) => {//获取wx浏览器支付信息
    return request({
        method: 'post',
        url: `${fixUrl}/api/order/payment/applyWechatpay`,
        data,
    })
}
export {
    getPayInfo,
    getPayInfoNew,
    applyAlipay,
    applyAlipayNew,
    applyWechatpay,
    applyWechatpayNew,
    getPayState,
    getPayWXInfo
}



// WEBPACK FOOTER //
// ./src/api/pay.js